type MappedObject = { [key: string]: string }

export enum RouteKey {
  INDEX = "INDEX",
  ADD_DRINK = "ADD_DRINK",
  SET_GOAL = "SET_GOAL",
  HISTORY = "HISTORY",
}

export const RoutePath: MappedObject = Object.freeze({
  [RouteKey.INDEX]: "/",
  [RouteKey.ADD_DRINK]: "/add-drink",
  [RouteKey.SET_GOAL]: "/set-goal",
  [RouteKey.HISTORY]: "/history",
});

export const RouteTitle: MappedObject = Object.freeze({
  [RouteKey.INDEX]: "",
  [RouteKey.ADD_DRINK]: "Add drink",
  [RouteKey.SET_GOAL]: "Set goal",
  [RouteKey.HISTORY]: "History",
});